import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
	name: 'urlSegura'
})
export class UrlSeguraPipe implements PipeTransform {

	constructor(private _sanitizer: DomSanitizer) {
	}

	transform(url: string, esRecurso: boolean = false): SafeUrl | SafeResourceUrl {
		if (esRecurso) {
			return this._sanitizer.bypassSecurityTrustResourceUrl(url);
		}
		else {
			return this._sanitizer.bypassSecurityTrustUrl(url);
		}
	}

}